<template>
  <span class="jom-formula" v-if="this.data.math" v-html="this.data.math" />
  <span class="jom-formula" v-else-if="this.data.latex">{{data.latex}}</span>
  <span v-else-if="this.data.graphicsData && this.data.graphicsData.small">
    <img class="math" v-if="layout != 'rc'" v-lazy="this.data.graphicsData.small" :data-width="width" alt="math"/>
    <img class="math" v-else :src="this.data.graphicsData.small" :style="{'width' : width + 'px'}" alt="math"/>
  </span>
</template>

<script>
  export default {
    props: [
      'data'
    ],
    data () {
      return {
        width: null
      }
    },
    created () {
      if(this.data.graphicsData == null ){
        return
      }else if(this.data.graphicsData.width != null){
        this.width = this.data.graphicsData.width * this.GLOBAL.deviceDPI.x / 25.4*1.2
      }
    }
  }
</script>

<style lang="scss">
  .jom-formula{
    padding: 0 5px;
    font-size:1.6rem;
    flex-grow:1;
    text-align: center;
    overflow-x:auto;
    overflow-y:hidden;
    pointer-events: none;
  }
  img.math{
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/formula/math.vue